import Store from "@/store/index.js";
import axios from 'axios';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
    async DatosPerfil() {
        let response = await axios.post(`${domain.domainNameForApi}Perfil/DatosPerfil`);
        return response.data[0];
    },
    async FirmaElectronicaObtenerDatos() {
        let response = await axios.post(`${domain.domainNameForApi}Perfil/FirmaElectronicaObtenerDatos`);
        return response.data;
    },
    async ValidarContrasenia(password) {
        var formData = new FormData();
        formData.append("password", password);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/ValidarContrasenia`, formData);
        return response.data;
    },
    async ValidarEFirma(efirma) {
        var formData = new FormData();
        formData.append("efirma", efirma);
        let response = await axios.post(`${domain.domainNameForApi}Movimientos/ValidarEFirma`, formData);
        return response.data;
    },
    async VerificarContenidoFirma(efirma) {
        var formData = new FormData();
        formData.append("firmaNueva", efirma);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/VerificarContenidoFirma`, formData);
        return response.data;
    },
    async VerificarCoincidenciasFirma(efirma, efirmaNueva) {
        var formData = new FormData();
        formData.append("FirmaAnterior", efirma);
        formData.append("FirmaNueva", efirmaNueva);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/VerificarCoincidenciasFirma`, formData);
        return response.data;
    },
    async ModificarFirma(efirma) {
        var formData = new FormData();
        formData.append("NuevaFirma", efirma);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/ModificarFirma`, formData);
        return response;
    },
    async VerificarHistorialContrasena(password) {
        var formData = new FormData();
        formData.append("ContNueva", password);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/VerificarHistorialContrasena`, formData);
        return response.data;
    },
    async VerificarPassWordconFirma(password) {
        var formData = new FormData();
        formData.append("ContNueva", password);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/VerificarPassWordconFirma`, formData);
        return response.data;
    },
    async ModificarPassword(password, passwordNew) {
        var formData = new FormData();
        formData.append("ContrasenaAnterior", password);
        formData.append("NuevaContrasena", passwordNew);
        let response = await axios.post(`${domain.domainNameForApi}Perfil/ModificarPassword`, formData);
        return response;
    },
    async ModificarTipoLlamada(tipo) {
        var formData = new FormData();
        formData.append("tipo", tipo); 
        formData.append("uslogin", MetodosGenerales.ObtenerUserName());
        let response = await axios.post(`${domain.domainNameForApi}Perfil/ModificarTipoLlamada`, formData);
        return response;
    },
}